import {ErrorHandler, Injectable} from "@angular/core";
import {
  ElasticSearchExceptionHandler,
  ExceptionHandlerRule,
  FremdsystemErrorExceptionHandler,
  FremdsystemNeskoErrorExceptionHandler,
  IcpPrintExceptionHandler,
  LogAndAlertExceptionHandler,
  MizenExceptionHandler,
  NoPermissionExceptionHandler,
  SearchResultValidationExceptionHandler,
  TooManyRequestsExceptionHandler,
  UnauthorizedExceptionHandler
} from "./exception-handler-rule";


/*
 @whatItDoes: Inspired by the Default Error Handler of the Engineering Stack (BedagErrorHandler),
 extended to also log Errors on the Server, Copy Stack to Clipboard and Send Mail.
 */
@Injectable()
export class CapExceptionHandler extends ErrorHandler {


  protected exceptionHandlerRuleChain: Array<ExceptionHandlerRule>;

  constructor(protected searchResultValidationRule: SearchResultValidationExceptionHandler,
              protected mizenExceptionRule: MizenExceptionHandler,
              protected unauthorizedRule: UnauthorizedExceptionHandler,
              protected noPermissionRule: NoPermissionExceptionHandler,
              protected tooManyRequestsRule: TooManyRequestsExceptionHandler,
              protected fremdsystemErrorRule: FremdsystemErrorExceptionHandler,
              protected fremdsystemNeskoErrorRule: FremdsystemNeskoErrorExceptionHandler,
              protected esErrorRule: ElasticSearchExceptionHandler,
              protected icpPrintExceptionRule: IcpPrintExceptionHandler,
              protected logAndAlertRule: LogAndAlertExceptionHandler
  ) {
    super();
    this.exceptionHandlerRuleChain = [fremdsystemNeskoErrorRule, searchResultValidationRule, mizenExceptionRule, unauthorizedRule, noPermissionRule, tooManyRequestsRule, fremdsystemErrorRule, esErrorRule, icpPrintExceptionRule, logAndAlertRule];
  }

  handleError(error: any) {
    for (const rule of this.exceptionHandlerRuleChain) {
      if (rule.errorHandled(error)) {
        return;
      }
    }
    super.handleError(error);
  }
}

